import { ApConfig } from 'src/app/classes/models/ap-config';
import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';

export class ApVendorMeta extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ApVendorMetaProperties: (
    | {
        property: keyof ApVendorMeta;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ApVendorMeta;
        type: 'alias';
      }
    | {
        property: keyof ApVendorMeta;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'ApConfigId', type: 'column', dataType: 'number' },
    { property: 'vendorKey', type: 'column', dataType: 'string' },
    { property: 'allowLink', type: 'column', dataType: 'boolean' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'ApConfig', model: 'ApConfig', type: 'association' }
  ];

  static {
    ApVendorMeta.ApVendorMetaProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        ApVendorMeta.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        ApVendorMeta.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        ApVendorMeta.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(ApVendorMetaObject: Partial<ApVendorMeta>) {
    super();

    ApVendorMeta.ApVendorMetaProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = ApVendorMetaObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  ApConfigId?: number;
  vendorKey?: string;
  allowLink?: boolean;
  createdAt?: Date;
  updatedAt?: Date;

  ApConfig?: ApConfig;
}
